(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.md-faq__item').forEach(function (item) {
    var summary = item.querySelector('.md-faq__question');
    var collapse = item.querySelector('.md-faq__collapse');
    if (!summary || !collapse) return;
    item.classList.add('md-faq--js');
    if (item.open) item.classList.add('is-open');

    var anim = null;
    var duration = function () {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280;
    };
    var run = function (from, to, done) {
      if (anim) anim.cancel();
      anim = collapse.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: duration(), easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' }
      );
      anim.onfinish = function () { anim = null; if (done) done(); };
    };

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (item.classList.contains('is-open')) {
        var from = collapse.offsetHeight;
        item.classList.remove('is-open');
        run(from, 0, function () { item.open = false; });
      } else {
        var start = collapse.offsetHeight; // 0, or mid-flight when interrupting
        item.open = true;
        item.classList.add('is-open');
        run(start, collapse.scrollHeight);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-presell-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.md-presell-bar-root').forEach((root) => {
    const sentinel = root.querySelector('.md-presell-bar__sentinel');
    const bar = root.querySelector('.md-presell-bar');
    if (!sentinel || !bar || bar.classList.contains('is-visible')) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-md-reviews-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = btn.closest('.md-reviews').querySelector('[data-md-reviews]');
      grid.querySelectorAll('.md-review[hidden]').forEach(function (card) {
        card.removeAttribute('hidden');
      });
      btn.closest('.md-reviews__more-wrap').setAttribute('hidden', '');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-track-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.md-track-order__form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('.md-track-order__input');
      const number = input.value.trim();
      if (!number) {
        input.focus();
        return;
      }
      window.open(form.dataset.trackUrl + encodeURIComponent(number), '_blank', 'noopener');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-video-proof"] && !Shopify.designMode) return;
  try {
    
  class MDVideoFacade extends HTMLElement {
    connectedCallback() {
      this.querySelector('[ref="poster"]')?.addEventListener('click', () => this.#load(), { once: true });
    }

    #load() {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${this.dataset.videoId}?autoplay=1&rel=0`;
      iframe.title = this.dataset.title || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'md-video__iframe';
      this.replaceChildren(iframe);
    }
  }

  if (!customElements.get('md-video-facade')) {
    customElements.define('md-video-facade', MDVideoFacade);
  }

  } catch(e) { console.error(e); }
})();
})();
